
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/units/[[...slug]]",
      function () {
        return require("private-next-pages/units/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/units/[[...slug]]"])
      });
    }
  